<template>
    <div ref="dropdown-link" class="dropdown-link relative" @click="onDropdownLinkClick">

        <div v-if="this.$slots.link"  role="button"
             class="select-none flex justify-between items-center">
            <slot name="link"></slot>
        </div>

        <div v-if="this.$slots.dropdown"
             class="absolute right-0" v-show="openLocal">
            <slot name="dropdown"></slot>
        </div>

    </div>
</template>

<script>
  /*
  Usage:
  <dropdown-link :open="[default false]">
      <a slot="link" href="#">
      ... toggle button html
      </a>

      <div slot="dropdown">
          ... dropdown html
      </div>
  </dropdown-link>
   */

  export default {
    name: 'dropdown-link',
    data() {
      return {
        openLocal: this.open
      }
    },
    props: {
      open: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      handleOutsideClick() {
        this.openLocal = false
      },
      onDropdownLinkClick() {
        this.openLocal = !this.openLocal

        if (this.openLocal) {
          document.body.addEventListener('mouseup', this.handleOutsideClick, true)
          document.addEventListener('keydown', event => {
            if (event.key === 'Escape' || event.keyCode === 27) {
              this.openLocal = false
            }
          });

        }
      }
    },

    mounted() {
    },
  }</script>

<style scoped lang="scss">
    .btn-dropdown-link{
        @apply appearance-none flex items-center font-medium  px-2 py-2 rounded;
    }
    .btn-dropdown-link:hover{
        @apply bg-gray-100
    }
    .btn-dropdown{
        @apply whitespace-no-wrap px-2 pb-2 text-gray-500 no-underline;
    }
    .btn-dropdown:hover{
        @apply text-green-500;
    }
</style>